import React from 'react';
import { createRoot } from 'react-dom/client';

import { SchoolReviewForm } from '../main-app/components/ReviewForm';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-funders-school-review-form');

  if (!node) return;

  const schoolId = node.getAttribute('data-school-id');
  const placeId = node.getAttribute('data-place-id');
  const minCommentLength = node.getAttribute('data-school-min-comment-length');
  const root = createRoot(node);
  root.render(<SchoolReviewForm schoolId={schoolId} placeId={placeId} minCommentLength={minCommentLength} />);
});
